import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Hotels from "./pages/Hotels";
import BonvoySignup from "./pages/BonvoySignup";
import SignIn from "./pages/SignIn";
// Temporarily disable Toaster to isolate issues
// import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hotels" element={<Hotels />} />
          <Route path="/register" element={<BonvoySignup />} />
          <Route path="/signup" element={<BonvoySignup />} />
          <Route path="/signin" element={<SignIn />} />
        </Routes>
        {/* <Toaster /> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
